<!--
@作者 王
@创建于 2021/3/15 20:02
-->

<template>
  <div>
    {{formData.value}}
    <el-upload
        class="upload-demo"
        :action="uploadApi"
        :limit="formData.limit || 9"
        :multiple="formData.multiple"
        :headers="headers"
        :on-exceed="formData.onExceed || onExceed"
        :on-change="formData.onChange"
        :before-upload="formData.beforeUpload"
        :on-success="onSuccess"
        :on-preview="formData.onPreview || onPreview"
        :on-progress="onProgress"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :show-file-list="false"
        :drag="formData.drag"
        :list-type="formData.listType || 'text'"
        :file-list="fileList"
        :accept="formData.accept">
      <el-button size="small" type="primary">{{formData.text || '点击上传'}}</el-button>
      <div class="el-upload-list--picture-card" style="display: block" slot="tip" v-if="formData.showFileList !== false">
        <div style="position: relative;display: inline-block;margin: 5px;width: 146px; height: 146px;overflow: hidden;border-radius: 6px" :key="index" v-for="(file,index) in fileList">
          <el-image
                  style="width: 146px; height: 146px"
                  :src="file.url">
            <div slot="error" class="image-slot">
              <i class="el-icon-document"></i>
            </div>
          </el-image>
          <span class="el-upload-list__item-actions">
        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
          <i class="el-icon-zoom-in"></i>
        </span>
        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(index)">
          <i class="el-icon-delete"></i>
        </span>
      </span>
        </div>

      </div>
    </el-upload>
  </div>
</template>

<script>
import {uploadApi, getImgURLApi} from "../../../server/system";

export default {
  name: "lj-upload",
  props: {
    formData: {
      type: Object
    }
  },
  data() {
    return {
      uploadApi,
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      headers: {
        'x-token': this.$store.state.token,
        'x-sessionId': this.$store.state.sessionID
      }
    }
  },
  methods: {
    handleRemove(index) {
      if (Array.isArray(this.formData.value)){
        this.formData.value.splice(index,1)
      }else if (this.formData.value.indexOf(',') > 0){
        let arr = this.formData.value.split(',');
        arr.splice(index,1);
        this.formData.value = arr.join(',')
      }else{
        this.formData.value = ''
      }
    },
    handlePictureCardPreview(file) {
      window.open(file.url)
    },
    onSuccess(res) {
      if (Array.isArray(this.formData.value)){
        this.formData.value.push(res.data.id)
      }else if (this.formData.value.indexOf(',') > 0 || (this.formData.value && this.formData.limit !== 1)){
        this.formData.value += ','+res.data.id
      }else{
        this.formData.value = res.data.id
      }
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除？`);
    },
    onPreview(file){
      window.open(file.url)
    },
    onProgress(event, file, fileList) {
      console.log(event, file, fileList)
    },
    onExceed(files,fileList){
      console.error(`超出文件上传限制:个数:${this.formData.limit}`)
    }
  },
  async created(){
    if (Array.isArray(this.formData.value)){
      this.fileList = [];
      this.formData.value.forEach(i=>{
        getImgURLApi({id:i}).then(res=>{
          this.fileList.push({url:res.filePath})
        })
      })
    }else if (this.formData.value.indexOf(',') > 0){
      this.fileList = [];
      let arr = this.formData.value.split(',');
      for (let i = 0; i< arr.length;i++){
        let res = await getImgURLApi({id:arr[i]});
        this.fileList.push({url:res.filePath})
      }
    }else if (this.formData.value){
      getImgURLApi({id:this.formData.value}).then(res=>{
        this.fileList = [{url:res.filePath}]
      })
    }else{
      this.fileList = [];
    }
  },
  watch: {
   async 'formData.value'(value){
      if (Array.isArray(value)){
        this.fileList = [];
        value.forEach(i=>{
          getImgURLApi({id:i}).then(res=>{
            this.fileList.push({url:res.filePath})
          })
        })
      }else if (value.indexOf(',') > 0){
        this.fileList = [];
        let arr = value.split(',');
        for (let i = 0; i< arr.length;i++){
          let res = await getImgURLApi({id:arr[i]});
          this.fileList.push({url:res.filePath})
        }
      }else if (value){
        getImgURLApi({id:value}).then(res=>{
          this.fileList = [{url:res.filePath}]
        })
      }else{
        this.fileList = [];
      }
    }
  }
}
</script>

<style lang="less">
.ljupload-img{
  height: 100%;
}
  .image-slot{
    background: rgba(0,0,0,0.3);
    height: 146px;
    color: white;
    font-size: 80px;
    display: flex;
    .el-icon-document{
      margin: auto;
    }
  }
</style>
